/** Stable keys for built-in Cotera workflow renderable nodes. */
export const WORKFLOW_RENDER_NODE_KEYS = {
  webhookTrigger: 'webhook-trigger',
  cronTrigger: 'cron-trigger',
  eventTrigger: 'event-trigger',
  datasetTrigger: 'dataset-trigger',
  agent: 'agent',
  forEach: 'for-each',
  adHocAgent: 'ad-hoc-agent',
  completeToolCall: 'complete-tool-call',
  toolCall: 'tool-call',
  filter: 'filter',
  debounce: 'debounce',
  emitEvent: 'emit-event',
  mapper: 'mapper',
  bucket: 'bucket',
  groupBy: 'group-by',
  runWorkflow: 'run-workflow',
  runInput: 'run-input',
  unknownTrigger: 'unknown-trigger',
  unknownGraphNode: 'unknown-graph-node',
} as const;

export type WorkflowRenderNodeKey =
  (typeof WORKFLOW_RENDER_NODE_KEYS)[keyof typeof WORKFLOW_RENDER_NODE_KEYS];
